<template>
  <div class="bg-blue-100" style="padding: 15px 30px">
    <span class="body">{{ t('travellers.panelIntro') }}</span>
  </div>
</template>

<script lang="ts" setup>
  // Translations
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()
</script>
